import { Dialogo, Kbd } from '../components/Ui';

const ATAJOS: { grupo: string; items: [string[], string][] }[] = [
  {
    grupo: 'Global',
    items: [
      [['C'], 'Crear caso'],
      [['/'], 'Buscar'],
      [['Ctrl', 'K'], 'Paleta de comandos'],
      [['?'], 'Ver esta ayuda'],
      [['Esc'], 'Cerrar panel o diálogo'],
    ],
  },
  {
    grupo: 'Navegación',
    items: [
      [['G', 'T'], 'Ir al tablero'],
      [['G', 'L'], 'Ir a la lista'],
      [['G', 'M'], 'Ir a Mi trabajo'],
    ],
  },
  {
    grupo: 'Listas y menús',
    items: [
      [['↑', '↓'], 'Moverse entre opciones'],
      [['Enter'], 'Abrir o elegir'],
      [['←', '→'], 'Cambiar de pestaña'],
    ],
  },
];

export function DialogoAtajos({ abierto, alCerrar }: { abierto: boolean; alCerrar: () => void }) {
  return (
    <Dialogo abierto={abierto} alCerrar={alCerrar} titulo="Atajos de teclado" ancho={560}>
      <div className="atajos">
        {ATAJOS.map((g) => (
          <section key={g.grupo}>
            <h3>{g.grupo}</h3>
            <dl>
              {g.items.map(([teclas, texto]) => (
                <div key={texto}>
                  <dt>{texto}</dt>
                  <dd>
                    {teclas.map((t, i) => (
                      <span key={t}>
                        {i > 0 && teclas[0] === 'G' && <span className="atajos__luego">luego</span>}
                        <Kbd>{t}</Kbd>
                      </span>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialogo>
  );
}
